/* eslint-disable react/jsx-props-no-spreading */
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import NewsArticleList from './news-article-list';

export default function NewsItems() {
  const options = {
    margin: 10,
    responsiveClass: true,
    dots: false,
    autoplay: true,
    smartSpeed: 500,
    responsive: {
      0: {
        items: 1,
      },
      329: {
        items: 1,
      },
      640: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1024: {
        items: 3,
      },
    },
  };

  return (
    <OwlCarousel className="owl-theme" loop {...options}>
      { NewsArticleList.map((value) => (
        <div
          className="flex flex-col gap-1 justify-center rounded-lg min-h-[350px]
                  transition ease-in-out delay-150
                  hover:shadow-b-xl hover:-translate-y-3
                  md:min-h-[450px] sm:gap-3 group"
          key={value.id}
        >
          <div className="lex flex-col h-1/2">
            <img src={value.image_url} alt="..." className="sm:w-full object-contain rounded-t-xl" />
          </div>
          <ul className="flex flex-wrap gap-2 px-1">
            {
              value.tag.map((item, index) => (
                <li className="text-xs font-bold bg-main text-white p-1 font-serif" key={`${item.id}&${index.name}`}>{item.name}</li>
              ))
            }
          </ul>
          <div className="px-1 min-h-[50px] xl:min-h-[60px]">
            <h3 className="text-left font-serif text-xs md:text-lg lg:text-xl group-hover:text-main group-hover:font-bold">{value.title}</h3>
          </div>
          <div className="px-1 flex justify-start">
            <p className="font-italic text-xs md:text-md">{value.date}</p>
          </div>
        </div>
      ))}
    </OwlCarousel>
  );
}
